import React from 'react'
import PropTypes from 'prop-types'; // ES6 
import {Alert, Fade } from 'reactstrap';

Alert.propTypes = {
  className: PropTypes.string,
  closeClassName: PropTypes.string,
  color: PropTypes.string, // default: 'success'
  isOpen: PropTypes.bool,  // default: true
  toggle: PropTypes.func,
  tag: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  // Controls the transition of the alert fading in and out
  // See Fade for more details
  transition: PropTypes.shape(Fade.propTypes),
}


// Iterate over each message object and print them
// in an unordered list
const Messages = (props) => {
  const { messages, className } = props
  let hasData = false
  if (messages && messages.length){
    for (let i = 0; i < messages.length; i++) { 
      if (messages[i].body != '')
      {
        hasData = true
        break
      }
    }
  }
  if (hasData){
    return (
      <div>
        {messages.map(message => (
          <Alert className={className} color="success" key={message.time}>{message.body}</Alert>
        ))}
      </div>
    )
  }
  return (
    ""
  )
}

Messages.propTypes = {
  messages: PropTypes.arrayOf(
    PropTypes.shape({
      body: PropTypes.string,
      time: PropTypes.date,
    })),
}

export default Messages



// WEBPACK FOOTER //
// ./src/notifications/Messages.js